export const ContentDescriptionRowCount = 2;
